import {useTranslation} from "react-i18next";
import Modal from "../../../common/modal/Modal";
import {UserInfoPanel} from "./UserInfolPanel";
import TabNav from "../../../common/tab/TabNav";
import {UserDto} from "../../../client/user/User";
import {UserTranslKey} from "../UserTranslKey";

const iconProps = {
    type: "complex",
    name: "doc-filled",
};

export interface UserDetailPanelProps {
    user: UserDto;
    open: boolean;
    onClose: (updated: boolean) => void;
}

export default function UserDetailPanel(props: Readonly<UserDetailPanelProps>) {
    const {user, open, onClose} = props;
    const {t} = useTranslation();

    const userInfoTab = {
        label: t(UserTranslKey.USER_PROFILE_TITLE),
        content: <>
            {user &&
                <UserInfoPanel user={user} />
            }
        </>
    };

    return (
        <Modal
            open={open}
            label={t(UserTranslKey.USER_DETAIL)}
            iconProps={iconProps}
            onClose={() => onClose(false)}>

            <TabNav items={[userInfoTab]} />
        </Modal>
    );
}
